<template>
  <div class="products">
    <pictureModal/>

    <Banner />

    <bar :active="active" :productList="productList"/>

    <template v-for="(item, index) in productList">
      <priceTable v-if="item.groupname === '建議售價'" :productList="item" :key="item.groupname"/>
      <products v-else :productList="item" :key="index"/>
    </template>

    <Footer />
  </div>
</template>


<script>
// @ is an alias to /src
import pictureModal from '@/components/pictureModal.vue';
import Banner from '@/components/Banner_button.vue';
import bar from '@/components/products_bar.vue';
import products from '@/components/products_group.vue';
import priceTable from '@/components/price_table.vue';
import Footer from '@/components/footer_information.vue';

import products1and1 from '@/assets/products/products-1/product1.png';
import products1and2 from '@/assets/products/products-1/product2.png';
import products1and3 from '@/assets/products/products-1/product3.png';
import products1and4 from '@/assets/products/products-1/product4.png';
import products1and5 from '@/assets/products/products-1/product5.png';
import products1and6 from '@/assets/products/products-1/product6.png';

import products2and1 from '@/assets/products/products-2/product1.png';
import products2and2 from '@/assets/products/products-2/product2.png';
import products2and3 from '@/assets/products/products-2/product3.png';
import products2and4 from '@/assets/products/products-2/product4.png';
import products2and5 from '@/assets/products/products-2/product5.png';
import products2and6 from '@/assets/products/products-2/product6.png';

import products3and1 from '@/assets/products/products-3/product1.png';
import products3and2 from '@/assets/products/products-3/product2.png';
import products3and3 from '@/assets/products/products-3/product3.png';

import products4and1 from '@/assets/products/products-4/product1.png';
import products4and2 from '@/assets/products/products-4/product2.png';
import products4and3 from '@/assets/products/products-4/product3.png';
import products4and4 from '@/assets/products/products-4/product4.png';
import products4and5 from '@/assets/products/products-4/product5.png';

import products5and1 from '@/assets/products/products-5/product1.png';
import products5and2 from '@/assets/products/products-5/product2.png';

import products6and1 from '@/assets/products/products-6/product1.png';
import products6and2 from '@/assets/products/products-6/product2.png';
import products6and3 from '@/assets/products/products-6/product3.png';
import products6and4 from '@/assets/products/products-6/product4.png';

import products7and1 from '@/assets/products/products-7/product1.png';
import products7and2 from '@/assets/products/products-7/product2.png';

import products8and1 from '@/assets/products/products-8/product1.png';
import products8and2 from '@/assets/products/products-8/product2.png';
import products8and3 from '@/assets/products/products-8/product3.png';

import products9and1 from '@/assets/products/products-9/1-main.jpg';

import products10and1 from '@/assets/products/products-10/1-main.jpg';


export default {
  data() {
    return {
      active: 0,
      productList: [
        {
          groupname: '感測器',
          group: [
            {
              no: 1,
              DMdownload: '',
              productName: 'LoRaWAN環境感知感應器集中器(LoRa1485)',
              description: 'LoRaWAN環境感知感應器集中器(Linkit 7697、LoRaWAN通訊、WiFi通訊、太陽能板；空氣溫濕度光照度感測器、土壤溫溼度/氮磷鉀/酸鹼值感測器各1個。',
              componentList: [
                {
                  component: 'LoRa模組：',
                  spec: [
                    'Compliance to LoRaWAN 1.0.2',
                    'Built-in antenna with IPEX connector',
                    'Command set with LoRaWAN chip for easy configuration',
                    'LoRa Frequency Band: 920 ~ 925MHz ISM',
                    'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                    'LoRa Receive Sensitivity: -130dBm',
                    'Operating Temperature: -10ºC ~ 55ºC',
                    'LoRa Number of Channels: Configurable 8 channels',
                    'LoRa Security: AES 128',
                    'Storage Temperature: -10ºC ~ 60ºC',
                  ],
                },
                {
                  component: '土壤溫溼度/電導度感應器：',
                  spec: [
                    '直流供電: 3.6~30VDC',
                    '最大功耗:0.4w ',
                    '精準度:',
                    '土壤濕度±3%,土壤溫度±0.5攝氏',
                    '土壤電導率±3% ',
                    '土壤溫度量程:-40~80攝氏',
                    '土壤濕度量程:0%RH~100%RH ',
                    '土壤電導度量程:0-10000us/cm',
                    '通訊方式: RS485',
                  ],
                },
                {
                  component: '其他配件：',
                  spec: [
                    '太陽能板: 20W, 長440mm*寬340mm*厚17mm',
                    '電池: 鉛酸電池, 12V/7Ah',
                    '配件: 不銹鋼支架',
                  ],
                },
                {
                  component: '土壤酸鹼值感測器：',
                  spec: [

                    '測量精度: ±0.5pH',
                    '測量範圍: 0-14pH',
                    '工作溫度 0至65℃',
                    '響應速度小於15秒',
                    '串列傳輸速率: 2400/4800/9600',
                    '通訊方式: RS485',
                    '供電電源: 12V-24V DC',

                  ],
                },
                {
                  component: '土壤氮磷鉀感測器：',
                  spec: [
                    '測量精度: ±2%F.s',
                    '解析度: 1mg/kg（mg/l）',
                    '響應速度小於10秒',
                    '工作溫度 5至45℃',
                    '工作濕度 5至95%（相對濕度）、無凝結',
                    '串列傳輸速率 2400/4800/9600',
                    '通訊方式: RS485',
                    '供電電源: 12V-24V DC',
                  ],
                },
              ],
              pictures: [
                products1and1,
                products1and2,
                products1and3,
                products1and4,
                products1and5,
                products1and6,
              ],
            },
            {
              no: 2,
              DMdownload: '',
              productName: '土壤感測器組(LoRa2485) / (NB4485)',
              description: '(1)LoRa或NB-IoT通訊模組、藍芽晶片、太陽能板、鋰電池、土壤感測器一支。(2)可選配共二支土壤感測器。',
              componentList: [
                {
                  component: 'LoRa模組：',
                  spec: [
                    'Compliance to LoRaWAN 1.0.2',
                    'Built-in antenna with IPEX connector',
                    'Command set with LoRaWAN chip for easy configuration',
                    'LoRa Frequency Band: 920 ~ 925MHz ISM',
                    'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                    'LoRa Receive Sensitivity: -130dBm',
                    'Operating Temperature: -10ºC ~ 55ºC',
                    'LoRa Number of Channels: Configurable 8 channels',
                    'LoRa Security: AES 128',
                    'Storage Temperature: -10ºC ~ 60ºC',
                  ],
                },
                {
                  component: '藍芽晶片：(nRF52832)',
                  spec: [
                    'SoC效能至少2.4GHz以上',
                    '256KB/128KB快閃記憶體+32KB/16KB RAM',
                    '工作溫度範圍：-40℃至+105℃',
                    '電壓範圍：1.7V至3.6V',
                    '192kB快閃記憶體+ 24kB RAM',
                  ],
                },
                {
                  component: '土壤溫溼度/電導度感應器：',
                  spec: [
                    '直流供電: 3.6~30VDC',
                    '最大功耗:0.4w ',
                    '精準度:',
                    '土壤濕度±3%,土壤溫度±0.5攝氏',
                    '土壤電導率±3% ',
                    '土壤溫度量程:-40~80攝氏',
                    '土壤濕度量程:0%RH~100%RH ',
                    '土壤電導度量程:0-10000us/cm',
                    '通訊方式: RS485',
                  ],
                },
                {
                  component: '土壤氮磷鉀感測器：',
                  spec: [
                    '測量精度: ±2%F.scopedSlots',
                    '解析度: 1mg/kg（mg/l）',
                    '響應速度小於10秒',
                    '工作溫度 5至45℃',
                    '工作濕度 5至95%（相對濕度）、無凝結',
                    '串列傳輸速率 2400/4800/9600',
                    '通訊方式: RS485',
                    '供電電源: 12V-24V DC',
                  ],
                },
                {
                  component: 'NB模組：',
                  spec: [
                    'LTE UE Category NB1',
                    '3GPP NB-IoT Rel-14',
                    'Support Band: B3/B5/B8/B18/B26',
                    'Supply Voltage: 3.1 ~ 4.2V, Nominal 3.6V ',
                    'AT Command: 3GPP Rel-14',
                    'Operating Temperature: -35 ~ 75℃',
                    'Tx Output Power: 23dBm±2dB',
                    'Rx Sensitivity: -129dBm±1dB',
                  ],
                },
                {
                  component: '其他配件：',
                  spec: [
                    '太陽能板：5V/30mA, 65*65 mm',
                    '電池：鋰電池, 3.7V/2500mAh',
                    '控制器尺寸：長≤120mm, 直徑≤840mm',
                    '不銹鋼支架',
                    '3W 太陽能板',
                  ],
                },
                {
                  component: '土壤酸鹼值感測器：',
                  spec: [
                    '測量精度:±0.5pH',
                    '測量範圍: 0-14pH',
                    '工作溫度 0至65℃',
                    '響應速度小於15秒',
                    '串列傳輸速率: 2400/4800/9600',
                    '通訊方式: RS485',
                    '供電電源: 12V-24V DC',
                  ],
                },
              ],
              pictures: [
                products2and1,
                products2and2,
                products2and3,
                products2and4,
                products2and5,
                products2and6,
              ],
            },
          ],
        },
        {
          groupname: '氣象站',
          group: [
            {
              no: 3,
              DMdownload: '',
              productName: '簡易型氣象站',
              description: 'LoRa或NB通訊模組、藍芽晶片、太陽能板、鋰電池、風向、風速、雨量計。',
              componentList: [
                {
                  component: 'LoRa模組：',
                  spec: [
                    'Compliance to LoRaWAN 1.0.2',
                    'Built-in antenna with IPEX connector',
                    'Command set with LoRaWAN chip for easy configuration',
                    'LoRa Frequency Band: 920 ~ 925MHz ISM',
                    'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                    'LoRa Receive Sensitivity: -130dBm',
                    'Operating Temperature: -10ºC ~ 55ºC',
                    'LoRa Number of Channels: Configurable 8 channels',
                    'LoRa Security: AES 128',
                    'Storage Temperature: -10ºC ~ 60ºC',
                  ],
                },
                {
                  component: '藍芽晶片：',
                  spec: [
                    'SoC效能至少2.4GHz以上',
                    '256KB/128KB快閃記憶體+32KB/16KB RAM',
                    '工作溫度範圍：-40℃至+105℃',
                    '電壓範圍：1.7V至3.6V',
                    '192kB快閃記憶體+ 24kB RAM',
                  ],
                },
                {
                  component: '微氣象站：',
                  spec: [
                    '風向: 0~337.5度, ±22.5度',
                    '風速: 0~50 m/sec, ±0.75 m/s',
                    '雨量: 0~3553.5 mm, ±0.3mm',
                  ],
                },
                {
                  component: '其他配件：',
                  spec: [
                    '太陽能板: 5V/30mA, 65*65 mm',
                    '電池: 鋰電池, 3.7V/2500mAh',
                    '控制器尺寸: 長≤120mm, 直徑≤840mm',
                    '不銹鋼支架',
                    '3W 太陽能板',
                  ],
                },
                {
                  component: 'NB-IoT模組：',
                  spec: [
                    'LTE UE Category NB1',
                    '3GPP NB-IoT Rel-14',
                    'Support Band: B3/B5/B8/B18/B26',
                    'Supply Voltage: 3.1 ~ 4.2V, Nominal 3.6V ',
                    'AT Command: 3GPP Rel-14',
                    'Operating Temperature: -35 ~ 75℃',
                    'Tx Output Power: 23dBm±2dB',
                    'Rx Sensitivity: -129dBm±1dB',
                  ],
                },
              ],
              pictures: [
                products3and1,
                products3and2,
                products3and3,
              ],
            },
            {
              no: 4,
              DMdownload: '',
              productName: '微氣象站組',
              description: 'LoRa或NB通訊模組、藍芽晶片、太陽能板、鉛酸電池、風向、風速、雨量計、氣象百葉箱(空氣溫/濕度/光照度)。',
              componentList: [
                {
                  component: 'LoRa模組：',
                  spec: [
                    'Compliance to LoRaWAN 1.0.2',
                    'Built-in antenna with IPEX connector',
                    'Command set with LoRaWAN chip for easy configuration',
                    'LoRa Frequency Band: 920 ~ 925MHz ISM',
                    'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                    'LoRa Receive Sensitivity: -130dBm',
                    'Operating Temperature: -10ºC ~ 55ºC',
                    'LoRa Number of Channels: Configurable 8 channels',
                    'LoRa Security: AES 128',
                    'Storage Temperature: -10ºC ~ 60ºC',
                  ],
                },
                {
                  component: '藍芽晶片：',
                  spec: [
                    'SoC效能至少2.4GHz以上',
                    '256KB/128KB快閃記憶體+32KB/16KB RAM',
                    '工作溫度範圍：-40℃至+105℃',
                    '電壓範圍：1.7V至3.6V',
                    '192kB快閃記憶體+ 24kB RAM',
                  ],
                },
                {
                  component: '微氣象站：',
                  spec: [
                    '風向: 0~337.5度, ±22.5度',
                    '風速: 0~50 m/sec, ±0.75 m/s',
                    '雨量: 0~3553.5 mm, ±0.3mm',
                    '氣象百葉箱:',
                    '空氣溫度: -40℃ ~ +120℃, ±0.5℃',
                    '空氣濕度: 0%RH ~ 99%RH, ±3%RH',
                    '光照強度: 0~200,000Lux, ±7%',
                  ],
                },
                {
                  component: '其他配件：',
                  spec: [
                    '太陽能板: 5V/30mA, 65*65 mm',
                    '電池: 鋰電池, 3.7V/2500mAh',
                    '控制器尺寸: 長≤120mm, 直徑≤840mm',
                    '不銹鋼支架',
                    '3W 太陽能板',
                  ],
                },
                {
                  component: 'NB-IoT模組：',
                  spec: [
                    'LTE UE Category NB1',
                    '3GPP NB-IoT Rel-14',
                    'Support Band: B3/B5/B8/B18/B26',
                    'Supply Voltage: 3.1 ~ 4.2V, Nominal 3.6V ',
                    'AT Command: 3GPP Rel-14',
                    'Operating Temperature: -35 ~ 75℃',
                    'Tx Output Power: 23dBm±2dB',
                    'Rx Sensitivity: -129dBm±1dB',
                  ],
                },
              ],
              pictures: [
                products4and1,
                products4and2,
                products4and3,
                products4and4,
                products4and5,
              ],
            },
          ],
        },
        {
          groupname: '人工智慧自動澆灌系統',
          group: [
            {
              no: 5,
              DMdownload: '',
              productName: '人工智慧自動澆灌系統(LoRaP2P-IR)',
              description: '包含水閥、LoRa P2P智能水閥控制器、水錶各一個；施工及周邊耗材另計。',
              componentList: [
                {
                  component: 'LoRa P2P智能水閥控制器：',
                  spec: [
                    'Built-in antenna with IPEX connector',
                    'Command set with LoRaWAN chip for easy configuration',
                    'LoRa Frequency Band: 920 ~ 925MHz ISM',
                    'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                    'LoRa Receive Sensitivity: -130dBm',
                    'Operating Temperature: -10ºC ~ 55ºC',
                    'LoRa Number of Channels: Configurable 8 channels',
                    'LoRa Security: AES 128',
                    'Storage Temperature: -10ºC ~ 60ºC',
                  ],
                },
                {
                  component: 'LoRa P2P水錶：',
                  spec: [
                    'Meter can be submerged, protection class IP 68',
                    'Max. working pressure: PN10',
                    'Meter body: Corrosion proof copper alloy',
                    'Diameter：25mm',
                    'TransmitionProtocal: LoRa P2P',
                  ],
                },
                {
                  component: '水閥規格：',
                  spec: [
                    '銅材質',
                    '電壓：AC110V',
                    '常閉式 ( 通電打開 , 斷電關）',
                    '流量孔徑：25mm',
                    '壓力：0~8kg/cm2',
                    '流體溫度：-5～80℃',
                  ],
                },
              ],
              pictures: [
                products5and1,
                products5and2,
              ],
            },
          ],
        },
        {
          groupname: '通訊開發模組',
          group: [
            {
              no: 6,
              DMdownload: '',
              productName: 'NF-Tag開發板',
              description: 'NF-Tag開發板是用來開發NF-Tag相關的應用, 開發板具有的DAPLink功能, 可以直接透過USB接口(USB2), 與MCU介面所提供的虛擬COM埠連接到電腦, 達成開發過程中所需的燒錄和除錯等通信要求。',
              componentList: [
                {
                  component: 'NF-Tag開發板：',
                  spec: [
                    '接口: USB type C',
                    'DAPlink: 採用STM32晶片',
                    'NF-Tag主控晶片: nRF52810',
                    '電源輸入: 5V, 經由USB輸入',
                    '電源輸出: 3.3V/500mA',
                    'LED: 3色(紅/綠/藍)',
                    'I/O: 包括一般GPIO, SPI, I2C與ADC',
                  ],
                },
              ],
              pictures: [
                products6and1,
                products6and2,
                products6and3,
                products6and4,
              ],
            },
            {
              no: 7,
              DMdownload: '',
              productName: '長距離低功耗通訊開發模組',
              description: 'LoRa (2485)一組、NB-IoT通訊模組 (4485)一組、不包含 NB-IoT SIM卡',
              componentList: [
                {
                  component: '開發模組-LoRa (2553)：',
                  spec: [
                    '規格簡述：LoRa通訊模組、BLE藍芽通訊、GPS衛星定位、3軸加速器、溫濕度傳感器。使用LoRaWAN芯片設置命令，便於配置，相容於Arduino開發環境。',
                    '無線頻段：902 ~ 928MHz ISM',
                    '频道数量：Configurable 16 channels',
                    '工作電壓：3.6Vdc Li-ion Battery',
                    'GPS冷啟動：Less than 60 second',
                    '射功率：0.5W (up to 27 dBm)',
                    'LoRa接收靈敏度：-130dBm',
                    'GPS 接收墨敬度：-158dBm (Tracking)',
                    '天線類型：Built-in Bluetooth External SMA for GPS, LoRa',
                    'LoRa安全：AES 128',
                    '工作温度：-10℃~ 55℃',
                    '貯存溫度：-10℃ ~60℃',
                    '外形尺寸：68.6mm*53.4mm',
                  ],
                },
                {
                  component: '開發模組- NB-IoT (4553)：',
                  spec: [
                    '規格簡述：NB-IoT通訊模組、BLE藍芽通訊、GPS衛星定位、3軸加速器、RTC模組，相容於Arduino開發環境。',
                    'LTE UE Category NB1',
                    '3GPP NB-IoT Rel-14',
                    'Support Band: B3/B5/B8/B18/B26',
                    'Supply Voltage: 3.1 ~ 4.2V, Nominal 3.6V ',
                    'AT Command: 3GPP Rel-14',
                    'Tx Output Power: 23dBm±2dB',
                    'Rx Sensitivity: -129dBm±1dB',
                    'GPS Cold Start：Less than 60 second',
                    'Operating Temperature：-10℃~ 55℃',
                    'Storage Temperature：-10℃ ~60℃',
                    'Size：68.6mm*53.4mm',
                  ],
                },
              ],
              pictures: [
                products7and1,
                products7and2,
              ],
            },
            {
              no: 8,
              DMdownload: '',
              productName: '穿戴式裝置感應器',
              description: 'LoRa或NB通訊模、BLE藍芽通訊、GPS衛星定位、3軸加速器、溫濕度傳感器。',
              componentList: [
                {
                  component: '穿戴式裝置感應器-LoRa (2038)：',
                  spec: [
                    '無線頻段：902 ~ 928MHz ISM ',
                    '頻道數量：Configurable 16 channels ',
                    '工作電壓：3.6Vdc Li-ion Battery',
                    'GPS 冷啟動：Less than 60 second',
                    '發射功率：0.5W (up to 27 dBm)',
                    '外形尺寸：L:67 x W:36 x H:20 mm',
                    'LoRa接收靈敏度：-130dBm',
                    'GPS 接收靈敏度：-158dBm (Tracking)',
                    '天線類型：Built-in GPS, Bluetooth and LoRa antenna',
                    'LoRa安全：AES 128',
                    '工作溫度：-10ºC ~ 55ºC',
                    '貯存溫度：-10ºC ~ 60ºC',
                  ],
                },
                {
                  component: '穿戴式裝置感應器- NB-IoT (4038)',
                  spec: [
                    '規格簡述：NB-IoT通訊模組、BLE藍芽通訊、GPS衛星定位、3軸加速器、RTC模組，相容於Arduino開發環境。',
                    'LTE UE Category NB1',
                    '3GPP NB-IoT Rel-14',
                    'Support Band: B3/B5/B8/B18/B26',
                    'Supply Voltage: 3.1 ~ 4.2V, Nominal 3.6V ',
                    'AT Command: 3GPP Rel-14',
                    'Tx Output Power: 23dBm±2dB',
                    'Rx Sensitivity: -129dBm±1dB',
                    'GPS Cold Start：Less than 60 second',
                    'Operating Temperature：-10℃~ 55℃',
                    'Storage Temperature：-10℃ ~60℃',
                    'Size：L:67 x W:36 x H:20 mm ',
                  ],
                },
              ],
              pictures: [
                products8and1,
                products8and2,
                products8and3,
              ],
            },
          ],
        },
        {
          groupname: '數據收集與分析平台',
          group: [
            {
              no: 9,
              DMdownload: '',
              productName: '雲端智慧校園物聯網數據收集與分析平台',
              description: '一式帳號密碼，使用一年。',
              componentList: [
                {
                  component: '',
                  spec: [
                    '提供帳號密碼使用，登入後自動顯示學校校園地',
                    '每一個使用者帳戶可進行電子郵件修改、密碼修改',
                    '可編輯感應器的場域、子場域、所屬的MacAddress、名稱',
                    '可對每一個場域與子場域進行檢視、建立、編輯',
                    '可替每一場域建立多個子場域',
                    '可在校園地圖上拖曳圖標，標記感應器所在位置',
                    '可結合校園地圖顯示感應器位置、使用狀況、歷史軌跡',
                    '可使用報表數據瀏覽感應器歷史資料',
                    '報表數據可統計感應器每一小時之使用狀況',
                    '可於校園地圖上動態顯示 GPS 感應器的移動路線',
                    '可用圖表顯示感應器的即時與歷史使用電量資訊',
                    '具備安全認證存取功能的API, 供 APP 或網頁程式讀取感應器數據',
                    '使用 API 讀取數據時, 可以根據 MACaddress 以及時間或時段取得數據',
                  ],
                },
              ],
              pictures: [
                products9and1,
              ],
            },
            {
              no: 10,
              DMdownload: '',
              productName: '物聯網雲端農業數據收集與分析平台',
              description: '一式帳號密碼，使用一年。',
              componentList: [
                {
                  component: '',
                  spec: [
                    '提供帳號密碼使用。登入後顯示場域即時狀態有無異常。',
                    '使用者帳戶密碼可進行修改，亦可綁定信箱用於異常發生之通知。',
                    '可建立場域及場域所屬感應器，感應器包含溫度濕度光照風速等近40種。',
                    '可編輯場域的MacAddress、名稱。',
                    '可編輯場域所屬感應器的名稱、channel。',
                    '可對各場域的數據進行即時監控、長期數值檢視。',
                    '各場域或整體帳號可連結信箱以及Line並於數據異常時發出通知，Line通知為群組通知，單一場域可同時通知群組內數人。',
                    '可對不同場域、不同種類的感應器並依挑選時間進行交叉混合比較。',
                    '可建立多種控制器如水閥、風扇、電燈並提供三類控制方式，包含手動控制、定時控制、邏輯控制。',
                    '手動控制為即時控制，下完開關指令後控制器將立即開啟並依設定時間自動關閉，亦可再開啟後隨時中斷。',
                    '定時控制為週期控制，可設定每日或一週數日的某一時間開啟，並依設定時間自動關閉。',
                    '控制器連結場域數項感應器後可使用邏輯控制，設定各類數值臨界值的規則來開啟控制器，如土壤溫度>30且濕度<50或光照>2K時開啟30秒。',
                    '可建立農業日誌，紀錄各類澆水、施肥、定植等工作事項，並配合上傳照片影片等完整記錄場域狀況，也可在建立完成後重新編輯查看刪除。',
                    '農業日誌提供匯出功能，可挑選時段將所有日誌下載為excel方便使用。',
                  ],
                },
              ],
              pictures: [
                products10and1,
              ],
            },
          ],
        },
        {
          groupname: '建議售價',
          group: [
            {
              description: '以下僅供參考，產品的最終價格將依據其不同的通訊規格、尺寸、外觀、材質、功能或軟體版本而有所差異，歡迎來電洽詢！',
              priceTable: [
                {
                  category: '感測器',
                  items: [
                    {
                      no: 1,
                      name: 'LoRaWAN環境感知感應器集中器(LoRa1485)',
                      unit: '1組',
                      price: '20,000 元',
                    },
                    {
                      no: 2,
                      name: '土壤感測器組(LoRa2485) / (NB4485)',
                      unit: '1組',
                      price: '20,000 元起',
                    },
                  ],
                },
                {
                  category: '氣象站',
                  items: [
                    {
                      no: 3,
                      name: '簡易型氣象站',
                      unit: '1組',
                      price: '20,000 元',
                    },
                    {
                      no: 4,
                      name: '微氣象站組',
                      unit: '1組',
                      price: '40,000 元',
                    },
                  ],
                },
                {
                  category: '人工智慧自動澆灌系統',
                  items: [
                    {
                      no: 5,
                      name: '人工智慧自動澆灌系統(LoRaP2P-IR)',
                      unit: '1組',
                      price: '30,000 元起',
                    },
                  ],
                },
                {
                  category: '通訊開發模組',
                  items: [
                    {
                      no: 6,
                      name: 'NF-Tag開發板',
                      unit: '1組',
                      price: '8,000 元',
                    },
                    {
                      no: 7,
                      name: '長距離低功耗通訊開發模組',
                      unit: '1組',
                      price: '6,000 元起',
                    },
                    {
                      no: 8,
                      name: '穿戴式裝置感應器',
                      unit: '1組',
                      price: '4,500 元',
                    },
                  ],
                },
                {
                  category: '數據收集與分析平台',
                  items: [
                    {
                      no: 9,
                      name: '雲端智慧校園物聯網數據收集與分析平台',
                      unit: '1組',
                      price: '30,000 元起',
                    },
                    {
                      no: 10,
                      name: '數據收集與分析平台',
                      unit: '1組',
                      price: '30,000 元起',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  components: {
    pictureModal,
    Banner,
    bar,
    products,
    priceTable,
    Footer,
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, false);
  },
  destroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      const navContents = document.querySelectorAll('.products-group');
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop - 179);
      });
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n += 1) {
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      this.active = navIndex;
    },
  },
};
</script>

<style scoped lang="scss">
.products{
  position: relative;
  .picturemodal{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(51, 51, 51, 0.5);
    z-index: 5;
  }
}

</style>
